import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import { AuthProvider } from "@/auth";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import PricingPage from "@/pages/PricingPage";
import BrandsPage from "@/pages/BrandsPage";
import ConceptPage from "@/pages/ConceptPage";
import ContactSupportPage from "@/pages/ContactSupportPage";
import MethodPage from "@/pages/MethodPage";
import LoginPage from "@/pages/LoginPage";
import AccountPage from "@/pages/AccountPage";
import AdminPage from "@/pages/AdminPage";
import { ProjectsPage, ProjectDetailPage, LegalPage } from "@/pages/ProjectsLegalPages";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AuthCallback from "@/components/AuthCallback";
import { ScrollToTop } from "@/components/ScrollToTop";
import { CookieBanner } from "@/components/CookieBanner";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth session_id synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <CookieBanner />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/chi-siamo" element={<AboutPage />} />
        <Route path="/servizi" element={<PricingPage />} />
        <Route path="/pacchetti-prezzi" element={<PricingPage />} />
        <Route path="/brand-cataloghi" element={<BrandsPage />} />
        <Route path="/contatti-supporto" element={<ContactSupportPage />} />
        <Route path="/richiedi-concept" element={<ConceptPage />} />
        <Route path="/progetti" element={<ProjectsPage />} />
        <Route path="/progetti/:id" element={<ProjectDetailPage />} />
        <Route path="/metodo" element={<MethodPage />} />
        <Route path="/legal/:slug" element={<LegalPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/dashboard" element={<AccountPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
